export const gaEvent = ({ action, category, label }) => {
  if(window.gtag){
    window.gtag('event', action, {
      event_category: category,
      event_label: label
    })

    window.gtag('config', 'UA-140562798-1', {'page_path': `/form/${label.toLowerCase()}`, 'anonymize_ip': true })
  }
}